var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoExportar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_32794",
    "data-name": "Grupo 32794",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.999,
    height: 21.015,
    viewBox: "0 0 20.999 21.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_59436",
    "data-name": "Rect\\xE1ngulo 59436",
    width: 20.999,
    height: 21.015,
    fill: "#f8fbfd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32793",
    "data-name": "Grupo 32793",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_118190",
    "data-name": "Trazado 118190",
    d: "M16.339,18.3a.866.866,0,0,0-1.235.079,2.62,2.62,0,0,1-1.97.893H4.378a2.635,2.635,0,0,1-2.627-2.627V4.378A2.635,2.635,0,0,1,4.378,1.751H8.327a3.521,3.521,0,0,1,.429.017V6.129a2.635,2.635,0,0,0,2.627,2.627H16.47a.862.862,0,0,0,.692-.341.894.894,0,0,0,.158-.753,6.109,6.109,0,0,0-1.6-2.819L12.67,1.795A6.094,6.094,0,0,0,8.336,0H4.378A4.38,4.38,0,0,0,0,4.378V16.637a4.38,4.38,0,0,0,4.378,4.378h8.756a4.4,4.4,0,0,0,3.284-1.48.866.866,0,0,0-.079-1.235M10.507,2.329a4.449,4.449,0,0,1,.919.709l3.047,3.047a4.48,4.48,0,0,1,.7.919h-3.8a.878.878,0,0,1-.876-.876v-3.8ZM20.253,15.84l-1.41,1.41a.86.86,0,0,1-.622.254.9.9,0,0,1-.622-.254.872.872,0,0,1,0-1.235l1.13-1.13H12.25a.876.876,0,0,1,0-1.751h6.48L17.6,12a.873.873,0,1,1,1.235-1.235l1.41,1.41a2.605,2.605,0,0,1,0,3.669Z",
    fill: "#f8fbfd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoExportar);
export default __webpack_public_path__ + "static/media/Icono-Exportar.9470a6f3a9591bdc9657cb86262f3e47.svg";
export { ForwardRef as ReactComponent };